module.exports = __webpack_public_path__ + "static/media/1C.84ef2f00.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/Files/1C.pdf
// module id = 79
// module chunks = 0